import { api } from "./configs/axiosConfigs"

export const AdministratorAPI = {

    get: async (data?:any) => {
        const response = await api.get(
            '/adminCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    create: async (data: any) => {
        const response = await api.post(
            '/adminCompany/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    update: async (id: number, data: any) => {
        const response = await api.patch(
            `/adminCompany/${id}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    delete: async (id: number) => {
        const response = await api.delete(
            `/adminCompany/${id}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}